// extracted by mini-css-extract-plugin
export default {"toggle-switch":"aKk_pgJ","toggle-switch__label":"pxe38J9","toggle-switch__switch-wrapper":"zVcP9VQ","toggle-switch__switch-visual":"op14DM_","toggle-switch__input":"Q395Pts"};